import * as React from 'react'

import { observer } from 'mobx-react'

import { IPermitTypeField } from '~/client/graph'
import StruxhubTextValueSelector from '~/client/src/shared/components/StruxhubInputs/StruxhubSelector/StruxhubTextValueSelector'
import IPermitFieldsStore from '~/client/src/shared/models/IPermitFieldsStore'
import { EMPTY_STRING } from '~/client/src/shared/utils/usefulStrings'

import SitePermitCreationFormStore, {
  FormDropdownType,
} from '../../WorkflowCreationForm.store'
import PermitBaseFormField from './PermitBaseFormField'

interface IProps {
  typeField: IPermitTypeField
  isViewMode: boolean

  store: SitePermitCreationFormStore
  fieldsStore: IPermitFieldsStore

  tableId?: string
  tableRowIndex?: number
  parentInstanceId?: string
  parentValueIndex?: number
}

@observer
export default class PermitFormSelectField extends React.Component<IProps> {
  public render() {
    const {
      isViewMode,
      typeField,
      fieldsStore,
      tableId,
      tableRowIndex,
      parentInstanceId,
      parentValueIndex,
      store,
    } = this.props
    const { caption, isMandatory } = typeField

    const isChanged = fieldsStore.isFieldChanged(
      typeField.id,
      null,
      tableId,
      tableRowIndex,
      parentInstanceId,
      parentValueIndex,
    )

    return (
      <PermitBaseFormField
        typeField={typeField}
        fieldValues={this.fieldValues}
        isViewMode={isViewMode}
        parentInstanceId={parentInstanceId}
        parentValueIndex={parentValueIndex}
        store={store}
        fieldsStore={fieldsStore}
        componentRenderer={null}
      >
        <StruxhubTextValueSelector
          label={caption}
          isRequired={isMandatory}
          isChanged={isChanged}
          value={this.fieldValues?.join(', ') || EMPTY_STRING}
          onClick={this.onFieldClick}
        />
      </PermitBaseFormField>
    )
  }

  private get fieldValues(): string[] {
    const {
      typeField,
      fieldsStore,
      tableId,
      tableRowIndex,
      parentInstanceId,
      parentValueIndex,
    } = this.props

    const values = fieldsStore.getFieldValues<string>(
      typeField.id,
      tableId,
      tableRowIndex,
      false,
      parentInstanceId,
      parentValueIndex,
    )

    return values?.length ? values : ['']
  }

  private onFieldClick = () => {
    const { store, typeField, tableId, tableRowIndex } = this.props
    const {
      setSelectedField,
      setSelectedFieldDropdownType,
      setSelectedOnChangeHandler,
    } = store

    setSelectedField(typeField, 0, tableId, tableRowIndex)
    setSelectedFieldDropdownType(FormDropdownType.DEFAULT)
    setSelectedOnChangeHandler(this.onApply.bind(null))
  }

  private onApply = (newValue: string[]) => {
    const {
      typeField,
      fieldsStore,
      tableId,
      tableRowIndex,
      parentInstanceId,
      parentValueIndex,
    } = this.props
    const { changeFieldValue, changeTableFieldValue } = fieldsStore

    if (typeField.isMultiple) {
      return fieldsStore.changeMultipleFieldValues(
        typeField,
        newValue,
        parentInstanceId,
        parentValueIndex,
      )
    }

    const singleValue = newValue[0] || EMPTY_STRING
    if (!this.isTableField) {
      return changeFieldValue(
        typeField,
        0,
        singleValue,
        parentInstanceId,
        parentValueIndex,
      )
    }

    changeTableFieldValue(
      tableId,
      tableRowIndex,
      typeField,
      0,
      singleValue,
      parentInstanceId,
      parentValueIndex,
    )
  }

  private get isTableField(): boolean {
    return !!this.props.tableId
  }
}
